/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IGameData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {ISpinGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/ISpinServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {IDeadwoodGameData, IDeadwoodServerData} from "./data/IDeadwoodServerData";

export class DeadwoodServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseDoReelNudge(rawData:IDeadwoodGameData):boolean[] {
        return rawData.doReelNudge.concat();
    }

    public parseExtraSymbolsOnTop(rawData:IDeadwoodGameData, parsedSymbolNamesUnder:string[]):string[][] {
        this.filterBonusSymbols(rawData.extraSymbolsOnTop);
        this.filterWildSymbols(rawData.extraSymbolsOnTop);

        return ServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop, parsedSymbolNamesUnder);
    }
    public getAccumulatedRoundWin(data: IDeadwoodServerData): string {
        return data.accumulatedRoundWin;
    }


    public parseReels(rawData:IServerData):string[][] {
        this.filterBonusSymbols(rawData.reels);
        this.filterWildSymbols(rawData.reels);

        return super.parseReels(rawData);
    }

    public parseReelsEnteringFreespin(rawData:IGameData):string[][] | undefined {
        if(rawData.reelsEnteringFreespin != undefined) {
            this.filterBonusSymbols(rawData.reelsEnteringFreespin);
            this.filterWildSymbols(rawData.reelsEnteringFreespin);
        }

        return super.parseReelsEnteringFreespin(rawData);
    }

    private filterBonusSymbols(reels:string[][]) {
        return;

        //TODO: reels[0].forEach((symName:string, index:number) => {
        //     if(symName === "B") {
        //         reels[0][index] = "B1";
        //     }
        // });
        // reels[4].forEach((symName:string, index:number) => {
        //     if(symName === "B") {
        //         reels[4][index] = "B2";
        //     }
        // });
    }

    private filterWildSymbols(reels:string[][]) {
        for(let i:number = 1; i < 4; i++) {
            reels[i].forEach((symName:string, index:number) => {
                if(symName === "W") {
                    reels[i][index] = `W${i}`;
                }
            });
        }
    }

    public parseMultiplierOnReel(rawData:IDeadwoodServerData):number[] {
        if(rawData.multiplierOnReel == null) {
            return ArrayHelper.initArrayWithValues(5, () => 0);
        }

        return rawData.multiplierOnReel;
    }

    public parseBonusTriggeredThisSpin(rawData:IDeadwoodServerData):boolean {
        return rawData.bonusTriggeredThisSpin;
    }

    public parseBonusPositions(rawData:IDeadwoodServerData):number[] {
        return rawData.bonusPositions;
    }

    public parseFsSuperModeActive(rawData:IDeadwoodServerData):boolean {
        return rawData.fsSuperModeActive;
    }

    public parsePlayerFSSelection(rawData:IDeadwoodServerData):number {
        return rawData.playerFSSelection;
    }

    public parseNumberOfSpinsFreespin(rawData:IDeadwoodServerData):[number, number] {
        return rawData.numberOfSpinsFreespin;
    }

    //#276
    public parseNearWinReels(rawData:ISpinGameData):boolean[] {
        const nearWin:boolean[] = super.parseNearWinReels(rawData).concat();
        const win:number = parseFloat(rawData.totalSpinWinnings);
        if((win == null || win === 0) && nearWin[4]) {
            for(let i0:number = 2; i0 < 5; i0++) {
                const testSymbol:string = rawData.reels[0][i0];
                // Logger.logDev(`testSymbol is ${testSymbol}`);
                if(testSymbol === "B") {
                    continue;
                }
                for(let i1:number = 1; i1 < 5; i1++) {
                    // Logger.logDev(` testing symbol[1][${i1}] = ${rawData.reels[1][i1]}`);
                    if(rawData.reels[1][i1] === testSymbol || rawData.reels[1][i1].includes("L")) {
                        // Logger.logDev(`symbol[1][${i1}] = ${rawData.reels[1][i1]} has chance to win.`);
                        for(let i2:number = 1; i2 < 5; i2++) {
                            // Logger.logDev(`testing symbol[2][${i2}] = ${rawData.reels[2][i2]}`);
                            if(rawData.reels[2][i2] === testSymbol || rawData.reels[2][i2].includes("L")) {
                                // Logger.logDev(`symbol[2][${i2}] = ${rawData.reels[2][i2]} has chance to win. finished`);
                                // there is chance to win.
                                return nearWin;
                            }
                        }
                    }
                }
            }
            // no chance to win.
            nearWin[4] = false;
            Logger.logDev(`Modified server data nearWin[4] from true to false because of no win shootout nearWin.`);
            return nearWin;
        }
        return nearWin;
    }
}